<template>
  <v-menu
      v-model="menu" offset-y left>
    <template v-slot:activator="{ on }">
      <v-btn
          icon
          rounded
          class="ml-auto width-auto d-inline d-sm-none"
          v-on="on"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-for="(link, i) in links" :key="i" :to="link.to" link exact>
        <v-list-item-icon>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t(link.label) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <v-switch v-model="$vuetify.theme.dark" dense :label="$t('Dark Mode')" persistent-hint/>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- Authenticated -->
      <template v-if="authenticated">
        <v-divider/>
        <v-list-item v-for="(link, i) in authenticatedLinks" :key="links.length+i" :to="link.to" link exact>
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t(link.label) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

    </v-list>
  </v-menu>

</template>

<script>
import {mapState, mapGetters} from 'vuex'
import {hasLotteryEnabled, hasSportsBetEnabled} from '~/plugins/config'

export default {
  data: () => ({
    menu: false,
    links: [
      {label: 'Sign-up', to: {name: 'register'}, icon: 'mdi-account-plus'},
      {label: 'Tutorials', to: {name: 'tutorial.list'}, icon: 'mdi-server'},
      {label: 'Support', to: {name: 'support'}, icon: 'mdi-help'}
    ],
  }),
  computed: {
    ...mapGetters({authenticated: 'auth/check',}),
    authenticatedLinks(){
      const links = []
      if (hasLotteryEnabled()){
        links.push({label: 'Lottery', to: {name: 'user.lottery.tickets.tickets-in-process'}, icon: 'mdi-ticket'})
      }
      if (hasSportsBetEnabled()){
        links.push({label: 'Sports Bet', to: {name: `user.sports-bet.matches`}, icon: 'mdi-basketball'})
      }

      return links
    }
  }
}
</script>

<style lang="scss" scoped>
.main-tabs {
  @media screen and (max-width: 1024px) {
    display: none !important;
  }
}
</style>